import { render } from "./DiscussionComment.vue?vue&type=template&id=3be37276&scoped=true"
import script from "./DiscussionComment.vue?vue&type=script&lang=js"
export * from "./DiscussionComment.vue?vue&type=script&lang=js"

import "./DiscussionComment.vue?vue&type=style&index=0&id=3be37276&lang=sass&scoped=true"
import "./DiscussionComment.vue?vue&type=style&index=1&id=3be37276&lang=sass"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be37276"]])

export default __exports__